<template>
  <div class="app-container-v2 table-container-v2 has-footer-bar">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">{{ title }}</span>
      </div>
      <div class="title-right">
        <el-button plain class="button-v2 ml16" @click="handleDelete()">删除</el-button>
        <el-button type="primary" class="button-v2" @click="uploadModalShow = true">导入数据</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleExport">下载报表</el-button>
      </div>
    </div>

    <div class="table-body flex vertical" v-loading="loading">
      <air-table
          v-if="render"
          ref="airTable"
          class="table-v2"
          :columns="columns"
          :data="tableData"
          @checkbox-change="check"
          @checkbox-all="check"
      >
        <template #operation="{ row }">
          <div class="flex center mt4">
            <span class="text-button" @click="handleEdit(row)">编辑</span>
            <div class="divider ml10 mr10"></div>
            <span class="text-button" @click="handleDelete(row)">删除</span>
          </div>
        </template>
      </air-table>

      <vxe-pager
          class="pager-v2"
          background
          :current-page.sync="queryParams.page"
          :page-size.sync="queryParams.limit"
          :total="total"
          :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'Sizes', 'Total']"
          @page-change="getData"
      ></vxe-pager>
    </div>

    <air-footer-bar>
      <el-button plain class="button-v2" @click="$back">返回</el-button>
    </air-footer-bar>

    <el-drawer
        class="drawer-v2"
        title="编辑信息"
        :visible.sync="drawerShow"
        :wrapper-closable="false"
        size="600px"
    >
      <div class="air-drawer-container">
        <div class="air-drawer-body flex vertical">
          <el-form ref="form" class="form-v2 report-form" :model="form" :rules="formRules" label-width="160px" style="margin: 40px 0; padding: 0 30px;" size="small">
            <template v-for="item in formItemList">
              <el-form-item v-if="item.translates" class="fixed-height" :label="`${item.title}：`" :prop="item.field">
                <el-select v-model="form[item.field]" placeholder="请选择" filterable>
                  <el-option v-for="item in item.translates" :key="item.codeItemId" :value="item.codeItemId" :label="item.codeItemName" />
                </el-select>
              </el-form-item>
              <el-form-item v-else :label="`${item.title}：`" :prop="item.field">
                <el-input v-model="form[item.field]" class="input-v2" placeholder="请输入" maxlength="20" />
              </el-form-item>
            </template>
          </el-form>
        </div>
        <div class="air-drawer-footer flex jbetween acenter">
          <el-button plain class="button-v2" @click="drawerShow = false">取消</el-button>
          <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleSave">保存</el-button>
        </div>
      </div>
    </el-drawer>

    <air-confirm-v2
        :show.sync="confirmShow"
        :title="confirmTitle"
        :content="confirmContent"
        :confirm-function="confirmFunction"
    ></air-confirm-v2>

    <el-dialog class="modal-v2" title="导入数据" :visible.sync="uploadModalShow" :close-on-click-modal="false" width="700px" append-to-body>
      <div class="flex vertical center mt30 mb30">
        <air-upload-excel @get-upload-info="getUploadInfo"></air-upload-excel>
      </div>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="downloadTemplate">下载模板</el-button>
        <div class="flex acenter">
          <el-button plain class="button-v2" @click="uploadModalShow = false">取消</el-button>
          <el-button type="primary" class="button-v2" :disabled="!uploadInfo.fileId" :loading="submitLoading" @click="handleImport">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as api from '@/api/v2/sishang/report'

export default {
  name: 'SishangReportDetail',
  components: {},
  data() {
    return {
      render: false,
      title: '',
      loading: true,
      queryParams: {
        page: 1,
        limit: 20,
        reportId: undefined
      },
      total: 0,
      originColumns: [],
      columns: [],
      tableData: [],
      dictMap: {},
      checkedList: [],
      drawerShow: false,
      form: {},
      formRules: {
        r0010001: [{ required: true, message: '请输入', trigger: 'blur' }],
        r0010002: [{ required: true, message: '请输入', trigger: 'blur' }],
        r0010003: [{ required: true, message: '请选择', trigger: 'change' }],
        r0010004: [{ required: true, message: '请选择', trigger: 'change' }],
        r0010005: [{ required: true, message: '请选择', trigger: 'change' }],
      },
      submitLoading: false,
      confirmShow: false,
      confirmTitle: '',
      confirmContent: '',
      confirmFunction: undefined,
      uploadModalShow: false,
      uploadInfo: {}
    }
  },
  computed: {
    formItemList() {
      return this.originColumns.filter(item => item.field !== 'r0010020')
    }
  },
  created() {
    this.init()
  },
  methods: {
    async init() {
      this.title = this.$route.query.title
      this.queryParams.reportId = this.$route.query.id
      await api.selectR001Title(this.queryParams).then(res => {
        this.originColumns = res.data.data
        this.columns = res.data.data.map((item, index) => {
          let column = {
            title: item.columnName,
            field: item.field,
            originField: item.field,
            dictData: item.translates,
            minWidth: 140,
            align: 'center'
          }
          if (index < 2) {
            column.fixed = 'left'
          }
          return column
        })
      })
      this.getData()
    },
    getData() {
      this.loading = true
      api.selectR001ByPage(this.queryParams).then(res => {
        this.dictMap = this.$handleTableDictInColumns(this.columns, res.data.data.records)
        this.tableData = res.data.data.records
        this.total = res.data.data.total
        this.render = true
        this.loading = false
      })
    },
    check({ records }) {
      this.checkedList = records
    },
    handleExport() {
      this.submitLoading = true
      api.selectR001ForExport(this.queryParams.reportId).then(res => {
        this.$downloadFile(res)
      }).finally(() => this.submitLoading = false)
    },
    handleEdit(item) {
      this.form = item
      this.drawerShow = true
    },
    handleSave() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          api.updateR001(this.form).then(res => {
            if (res.data.code === 0) {
              this.$msgSuccess('保存成功')
              this.getData()
              this.drawerShow = false
            }
          }).finally(() => this.submitLoading = false)
        }
      })
    },
    handleDelete(item) {
      const ids = item ? [item.subId] : this.checkedList.map(item => item.subId)
      const names = item ? item.r0010001 : this.checkedList.map(item => item.r0010001).join('、')
      this.confirmShow = true
      this.confirmTitle = '删除'
      this.confirmContent = `确认删除「${names}」?`
      this.confirmFunction = () => {
        api.deleteR001({
          r001Id: ids
        }).then(() => {
          this.getData()
          this.$msgSuccess('删除成功')
        })
      }
    },
    downloadTemplate() {
      api.downloadtmpexcel(this.queryParams.reportId).then(res => {
        this.$downloadFile(res)
      })
    },
    getUploadInfo(e) {
      this.uploadInfo = e
    },
    handleImport() {
      this.submitLoading = true
      this.uploadInfo.reportId = this.queryParams.reportId
      this.uploadInfo.cusId = this.$userInfo.cusId
      api.batchUpdateR001List(this.uploadInfo).then(res => {
        if (res.data.code === 0) {
          this.$msgSuccess('导入成功')
          this.getData()
          this.uploadModalShow = false
        } else {
          this.$msgError(res.data.msg)
        }
      }).finally(() => this.submitLoading = false)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/air/assets/css/main.scss";
</style>
